import type { FunctionComponent } from 'react';
import dayjs, { Dayjs } from 'dayjs';

export interface TimeAgoProps {
  date: Dayjs | string | null | undefined;
  className?: string | undefined;
  NullComponent?: FunctionComponent | string;
}

const DefaultNullComponent = () => null;

export const TimeAgo: FunctionComponent<TimeAgoProps> = ({
  date,
  className,
  NullComponent = DefaultNullComponent,
}) => {
  if (!date) {
    return <NullComponent />;
  }

  const dayjsDate: Dayjs = typeof date === 'string' ? dayjs(date) : date;

  return (
    <span className={className} title={dayjsDate.format('L LTS')}>
      {dayjs().to(dayjsDate)}
    </span>
  );
};
